/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

import { GenerateWeekOptions, IPatternFieldsProps } from '../../AllSchedules.Model';

import { Options } from '../../../../../../Shared/Components/Common/Dropdown/Dropdown.styles';
import { wrapperStyles } from '../../AllJobs.Style';

const { textField } = wrapperStyles;

export const WeekField = ({ control, quarterName, onFieldChange, selectProps, patternType }: IPatternFieldsProps) => {
  const weekOptions = GenerateWeekOptions(patternType);

  return (
    <Controller
      name={`quarters.${quarterName}.week`}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          select
          label="Week"
          fullWidth
          sx={{ ...textField, width: '22.5rem', marginRight: '1.5rem' }}
          SelectProps={selectProps}
          onChange={(e) => {
            field.onChange(e);
            onFieldChange?.('week', e.target.value);
          }}>
          {weekOptions.map((option) => (
            <Options key={option.value} value={option.value}>
              {option.label}
            </Options>
          ))}
        </TextField>
      )}
    />
  );
};
